import type React from 'react';

export interface DomainBadgeProps {
  domainId: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function DomainBadge({ domainId, size = 'md', className }: DomainBadgeProps): React.JSX.Element {
  const color = `var(--d-${domainId})`;
  const classes = ['domain-badge', size === 'sm' && 'sm', className].filter(Boolean).join(' ');
  return (
    <span className={classes} style={{ borderColor: color, color }}>
      <span className="domain-dot" style={{ background: color }} aria-hidden="true" />
      {domainId}
    </span>
  );
}
